export const formatCurrency = (value: number) =>
  new Intl.NumberFormat('en-EN', {
    style: 'currency',
    currency: 'USD',
  }).format(value || 0)

export const formatCurrencyNoCent = (value: number) =>
  new Intl.NumberFormat('en-EN', {
    style: 'currency',
    currency: 'USD',
    maximumSignificantDigits: 3,
  }).format(value || 0)

export const formatPercentage = (value: number) =>
  new Intl.NumberFormat('en-EN', {
    style: 'percent',
    maximumFractionDigits: 2,
  }).format(value || 0)

export const formatPercentageShort = (value: number) =>
  new Intl.NumberFormat('en-EN', {
    style: 'percent',
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  }).format(value || 0)

export const shortNumber = (value: number) =>
  new Intl.NumberFormat('en-US', {
    notation: 'compact',
    maximumFractionDigits: 1,
  }).format(value || 0)

export const formatNumber = (value: number) => {
  const truncated = Math.floor(value || 0)
  return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(
    truncated,
  )
}

export const formatMilliseconds = (value: number) =>
  new Intl.NumberFormat('en-US', {
    style: 'unit',
    unit: 'millisecond',
  }).format(value || 0)

export const formatDate = (value?: number | Date | string) => {
  let result = ''
  try {
    result = new Intl.DateTimeFormat('en-US', {
      month: 'short',
      year: 'numeric',
    }).format(value as Date)
  } catch (error: unknown) {
    const msg = error instanceof Error ? error.message : String(error)

    result = `Invalid Date - ${msg}`
  }
  return result
}
